import React from 'react';
import classNames from 'classnames';
import './NumericTile.scss';
import { Text } from '@components/text';
import { TileItem } from '@components/tile';

export interface NumericTileProps {
  /** Size of the container, applies the appropriate gap. default medium. */
  size?: 'small' | 'medium' | 'large';
  number: number;
  className?: string;
}

/**
 * NumericTile Component - A styled TileItem specifically for the carousel numeric tile
 * @param size - Size of the number. default medium.
 * @param number - Number to display.
 * @param className - Additional class name.
 */
export const NumericTile: React.FC<NumericTileProps> = ({ size = 'medium', number, className }) => {
  return (
    <TileItem
      position="top-left"
      padding="none"
      className={classNames('vds-numeric-tile', `vds-numeric-tile--${size}`, className)}>
      <Text weight="black" variant="heading-01" className="vds-numeric-tile__number">
        {number}
      </Text>
    </TileItem>
  );
};
